module.exports = __webpack_public_path__ + "img/emp3-2.a9144bc4.jpg";